import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'development-summary-releases-field.summary.label',
		defaultMessage: 'Releases',
		description: '',
	},
});
